import style from '../UploadConfigModal.module.scss'
import { Button, Modal } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

interface UploadConfigFooterProps {
    onSubmit: () => void
    isValid: boolean
}

export const UploadConfigFooter = (props: UploadConfigFooterProps) => {
    const { onSubmit, isValid} = props

    return (
        <Modal.Footer className={style.windowPadding}>
            <Button
                variant="primary"
                className="app-btn-main app-btn-apply me-0"
                type="submit"
                onClick={onSubmit}
                disabled={!isValid}
            >
                <FormattedMessage id="buttons.upload" />
            </Button>
        </Modal.Footer>
    )
}